import { render, staticRenderFns } from "./Preview3D.vue?vue&type=template&id=46d3b95d&"
import script from "./Preview3D.vue?vue&type=script&lang=js&"
export * from "./Preview3D.vue?vue&type=script&lang=js&"
import style0 from "./Preview3D.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports